"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('messageFormatOption', {
    showBcc: null,
    showFrom: null,
    composeFormat: null,
    fontFamily: null,
    fontSize: null,
    isFontBold: null,
    isFontItalic: null,
    isFontUnderline: null,
    fontColor: null,
    isColorMenuShown: false,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/store/store.js
// module id = 2685
// module chunks = 2